import type { LaserficheConnectionDto, Team } from "@repo/types";
import { LaserficheMultiConnectionRow } from "./LaserficheMultiConnectionRow";

export type LaserficheConnectionMap = Record<string, LaserficheConnectionDto>;

export interface LaserficheMultiConnectionManagerProps {
  tenantId: string;
  teams: Team[];
  connections?: LaserficheConnectionMap;
  onEdit?: (tenantId: string, teamId?: string) => void;
  onConnect?: (tenantId: string, teamId?: string) => void;
  onDisconnect?: (tenantId: string, teamId?: string) => void;
}

export const LaserficheMultiConnectionManager = ({
  tenantId,
  teams,
  connections,
  onEdit,
  onConnect,
  onDisconnect,
}: LaserficheMultiConnectionManagerProps) => {
  return (
    <div className="flex flex-col gap-3">
      {/* Tenant Config */}
      <LaserficheMultiConnectionRow
        key="tenant"
        tenantId={tenantId}
        label="Default Connection"
        isConnected={!!connections?.[""]}
        onEdit={onEdit}
        onConnect={onConnect}
        onDisconnect={onDisconnect}
      />

      {/* Teams Config */}
      {teams.map((team) => (
        <LaserficheMultiConnectionRow
          key={team.id}
          tenantId={tenantId}
          team={team}
          label={
            <>
              Team: <em>{team.name}</em>
            </>
          }
          isConnected={!!connections?.[team.id]}
          onEdit={onEdit}
          onConnect={onConnect}
          onDisconnect={onDisconnect}
        />
      ))}
    </div>
  );
};
